import API from "shared/services/Api";
import {
  IDentistaContatoResponse,
  IDentistaContatoSavePayload,
  IDentistaContatoSaveResponse,
} from "shared/types/DentistaContato";

export const getDentistaContato = async (
  userId: string
): Promise<IDentistaContatoResponse> =>
  API.get(`/oc/dentista-contato?id=${userId}`);

export const saveDentistaContato = async (
  userId: string,
  data: IDentistaContatoSavePayload
): Promise<IDentistaContatoSaveResponse> =>
  API.post(`/oc/dentista-contato?id=${userId}`, data);
